import { Component, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProcessingService } from '../../../shared/services/processing.service';
import { ClickhouseService } from '../../../shared/services/clickhouse.service';
import { DOCUMENT } from '@angular/common';
import { AppModalService } from '../../../shared/services/app-modal.service';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppStateInterface } from '../../../store/state/app.state';
import { getBillingInfo } from '../../../store/actions/billing.actions';

@Component({
  selector: 'app-payform',
  templateUrl: './payform.component.html',
  styleUrls: ['./payform.component.scss'],
})
export class PayformComponent implements OnInit {
  @Input() public product: any;

  // This is kostul for Yaroslav!
  @Input() public onSuccessVipPurchaseCallback: Function | null = null;

  @Input() public modalVariant: any;
  @Input() public price: any;

  constructor(
    public activeModal: NgbActiveModal,
    private processingService: ProcessingService,
    private clickhouseService: ClickhouseService,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private modalService: AppModalService,
    private store: Store<AppStateInterface>,
  ) {
    this.processingService.onSuccess.subscribe(() => {
      this.activeModal.close();
      if (this.onSuccessVipPurchaseCallback) {
        this.onSuccessVipPurchaseCallback();
      } else {
        this.store.dispatch(getBillingInfo());
      }
      this.modalService.open({
        title: 'Transaction success!🥳',
        canClose: true,
        subtitle: 'Congratulations...',
        buttons: [
          {
            title: 'Continue',
            type: 'yellow',
            outline: true,
            callback: new Observable((subscriber) => {
              subscriber.next();
            }),
          },
        ],
      });
    });
    this.processingService.onMounted.subscribe(() => {
      this.clickhouseService.storeEvent('form_mounted').subscribe(() => {});
    });
  }

  ngOnInit(): void {
    if (this.document.querySelector('#processingLibScript')) {
      this.processingService.initPaymentForm(this.product, 'payment-form-body');
    } else {
      let script = this.renderer2.createElement('script');
      script.type = 'text/javascript';
      script.id = 'processingLibScript';
      script.src = 'https://gcdn.fx2.io/math-processing/processing.lib.js';
      script.onload = () => {
        this.processingService.initPaymentForm(this.product, 'payment-form-body');
      };
      this.renderer2.appendChild(this.document.head, script);
    }
  }
}
